import { Link } from 'react-router-dom'
import { ArrowLeft, Compass } from 'lucide-react'

export function NotFoundPage() {
  return (
    <div className="card flex min-h-[480px] flex-col items-center justify-center px-6 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-pine-50 text-pine-700"><Compass className="h-6 w-6" /></div>
      <div className="mt-5 text-xs font-bold uppercase tracking-[0.16em] text-pine-600">404</div>
      <h1 className="mt-2 text-2xl font-bold text-slate-950">That page isn’t here</h1>
      <p className="mt-2 max-w-sm text-sm leading-6 text-slate-500">The record may have moved, or the address may be incorrect.</p>
      <Link to="/" className="btn-primary mt-6"><ArrowLeft className="h-4 w-4" />Back to dashboard</Link>
    </div>
  )
}
